import { createFileRoute } from '@tanstack/react-router';
import { PRIVACY_URL } from '../lib/legal';

/** The policy is on the public site — see `lib/legal.ts`. `replace`, so Back skips this hop. */
export const Route = createFileRoute('/privacy')({
  beforeLoad: () => {
    window.location.replace(PRIVACY_URL);
  },
  component: () => null,
});
